import type { OperationContext } from "urql"

export const NETWORK_ONLY_OPERATION_CONTEXT: Partial<OperationContext> = {
  requestPolicy: "network-only",
  // Needed to work around double query issue in urql
  // https://opensea.slack.com/archives/C06UK16LTT4/p1729695494858519
  suspense: false,
}

export const SOLANA_CHAIN_ID = 1
